import { Fragment } from 'react';
import { medicalBookIcon } from '../../../components/common/Icons';

type Props = {
    handleCta?: () => void;
};

const mhBookIcon = medicalBookIcon();

const MHEmpty: React.FC<Props> = ({ handleCta }) => {
    return (
        <Fragment>
            <p className="text-13 w-168 m-auto text-center mb-26 text-darwin-neutral-800 font-400">
                You can see your patient's{' '}
                <span
                    onClick={handleCta}
                    className="font-700 text-darwin-accent-medical-history-orange-900 cursor-pointer hover:underline hover:underline-darwin-accent-medical-history-orange-900"
                >
                    medical history
                </span>{' '}
                here
            </p>
            <div className="mx-21 mb-26">
                <p className="text-10 font-700 bg-darwin-accent-investigations-ochre-900 text-white w-max m-auto px-10 py-5 relative top-11">
                    EXAMPLE
                </p>
                <div className="flex-col border border-darwin-accent-investigations-ochre-200 bg-darwin-accent-investigations-ochre-100 text-darwin-accent-investigations-ochre-900 pt-22 pb-16 pl-14 pr-10 space-y-22 text-13 rounded-4">
                    <div>
                        <p className="h-7 w-84 bg-darwin-accent-investigations-ochre-200 rounded-full"></p>
                        <p className="mt-6 mb-4">Diabetes Mellitus Type 2 (20y)</p>
                        <p className="h-7 w-full bg-darwin-accent-investigations-ochre-300 rounded-full"></p>
                    </div>
                    <div>
                        <p className="h-7 w-84 bg-darwin-accent-investigations-ochre-200 rounded-full"></p>
                        <p className="mt-6 mb-4">Smoking | Drinking</p>
                        <p className="h-7 w-full bg-darwin-accent-investigations-ochre-300 rounded-full"></p>
                    </div>
                </div>
            </div>

            {handleCta && (
                <button
                    onClick={handleCta}
                    className="flex items-center space-x-8 font-700 text-14 border border-darwin-primary-500 p-9 px-16 m-auto rounded-4 text-darwin-primary-500"
                >
                    <span>{mhBookIcon}</span>
                    <span>Add Medical History</span>
                </button>
            )}
        </Fragment>
    );
};

export default MHEmpty;
